import { useEffect, useRef, useState } from "react";
// import Topbar from "../../components/Topbar/Topbar";
// import { edit_icon } from "../../assets/img";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { edit_icon } from "../../assets/img/imgIndex";

const InappUpdate = () => {
  const [version, setVersion] = useState({
    user: { id: "", value: "" },
    delivery: { id: "", value: "" },
    receptionist: { id: "", value: "" },
    userIOS: { id: "", value: "" },
  });

  const [activeEdit, setActiveEdit] = useState(null);

  const userRef = useRef(null);
  const userIOSRef = useRef(null);
  const deliveryRef = useRef(null);
  const receptionistRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // 🧼 Allow only numbers and dots
    let cleaned = value.replace(/[^0-9.]/g, "");

    // 🚫 Prevent multiple dots in a row (1..2)
    cleaned = cleaned.replace(/\.{2,}/g, ".");

    // 🚫 Prevent starting with a dot (.1 → 0.1)
    if (cleaned.startsWith(".")) {
      cleaned = "0" + cleaned;
    }

    setVersion((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: cleaned,
      },
    }));
  };

  const handleEdit = (name) => {
    setActiveEdit((prev) => (prev === name ? null : name));

    setTimeout(() => {
      if (name === "user") userRef.current?.focus();
      if (name === "userIOS") userIOSRef.current?.focus();
      if (name === "delivery") deliveryRef.current?.focus();
      if (name === "receptionist") receptionistRef.current?.focus();
    }, 0);
  };

  const getInputClass = (isEditable) =>
    `input-box flex-grow-1 ${isEditable ? "input-editable" : "input-disabled"}`;

  const fetchVersion = async () => {
    const res = await get(URLS.VERSION_LIST_GET);
    console.log("resres", res);

    if (res?.status === "success") {
      const updatedVersion = {
        user: { id: "", value: "" },
        delivery: { id: "", value: "" },
        receptionist: { id: "", value: "" },
        userIOS: { id: "", value: "" },
      };

      res.data.forEach((item) => {
        if (item.type === 1) {
          updatedVersion.user = {
            id: item.id,
            value: item.setting_value,
          };
        }

        if (item.type === 2) {
          updatedVersion.userIOS = {
            id: item.id,
            value: item.setting_value,
          };
        }
        if (item.type === 4) {
          updatedVersion.delivery = {
            id: item.id,
            value: item.setting_value,
          };
        }
      });

      setVersion(updatedVersion);
    }
  };

  useEffect(() => {
    fetchVersion();
  }, []);

  const handleSubmit = async () => {
    if (!activeEdit) {
      toast.error("Please select a version to update");
      return;
    }
    const currentData = version[activeEdit];
    const value = currentData.value.trim();
    console.log("currentDatacurrentData", currentData);

    const numberRegex = /^\d+(\.\d+)+$/;

    if (!value) {
      toast.error("Version value is required");
      return;
    }

    if (!numberRegex.test(value)) {
      toast.error("Version value format is incorrcet");
      return;
    }

    const typeMap = {
      user: 1,
      userIOS: 2,
      delivery: 4,
    };

    const payload = new FormData();
    payload.append("type", typeMap[activeEdit]);
    payload.append("setting_value", value);

    // console.log("payload", payload);

    let url = URLS.VOW_VERSION_UPDATE + `${currentData.id}` + "/update/";

    // console.log("url", url);

    let res = await put(url, payload);

    if (res?.status == "success") {
      toast.success(res?.message);
      fetchVersion();
    }

    // setActiveEdit(null);
  };

  return (
    <div>
      {/* <Topbar header="Kadugudabba Settings" /> */}

      <h2 className="f2 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-4">
        Kadugudabba in-app updates
      </h2>

      {/* ---------------- Kadugudabba User ---------------- */}
      <div className="row mb-4">
        <div className="col-md-5">
          <h4 className="f2 mb-3">Kadugudabba User Android</h4>
          <label className="f3 mb-1">Current version</label>

          <div className="d-flex align-items-center gap-5">
            <input
              ref={userRef}
              type="text"
              name="user"
              placeholder="Kadugudabba user"
              value={version.user.value}
              onChange={handleChange}
              disabled={activeEdit !== "user"}
              className={getInputClass(activeEdit === "user")}
            />

            <button className="cust-btn" onClick={() => handleEdit("user")}>
              <img
                src={edit_icon}
                alt="edit"
                className={`edit-btn ${
                  activeEdit === "user" ? "active-edit" : ""
                }`}
              />
            </button>
          </div>
        </div>
        <div className="col-md-5">
          <h4 className="f2 mb-3">Kadugudabba User IOS</h4>
          <label className="f3 mb-1">Current version</label>

          <div className="d-flex align-items-center gap-5">
            <input
              ref={userIOSRef}
              type="text"
              name="userIOS"
              placeholder="Kadugudabba user"
              value={version?.userIOS?.value}
              onChange={handleChange}
              disabled={activeEdit !== "userIOS"}
              className={getInputClass(activeEdit === "userIOS")}
            />

            <button className="cust-btn" onClick={() => handleEdit("userIOS")}>
              <img
                src={edit_icon}
                alt="edit"
                className={`edit-btn ${
                  activeEdit === "userIOS" ? "active-edit" : ""
                }`}
              />
            </button>
          </div>
        </div>
        <div className="col-md-5 mt-5">
          <h4 className="f2 mb-3">Kadugudabba Delivery Partner Android</h4>
          <label className="f3 mb-1">Current version</label>

          <div className="d-flex align-items-center gap-5">
            <input
              ref={deliveryRef}
              type="text"
              name="delivery"
              placeholder="Kadugudabba Delivery Partner"
              value={version.delivery.value}
              onChange={handleChange}
              disabled={activeEdit !== "delivery"}
              className={getInputClass(activeEdit === "delivery")}
            />

            <button className="cust-btn" onClick={() => handleEdit("delivery")}>
              <img
                src={edit_icon}
                alt="edit"
                className={`edit-btn ${
                  activeEdit === "delivery" ? "active-edit" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      <hr />

      <div className="d-flex ac-jb mt-5">
        <div />
        <button onClick={handleSubmit} className="submit-btn mt-3">
          Update
        </button>
      </div>
    </div>
  );
};

export default InappUpdate;
